import { httpClientMarket } from 'Api/microservice-http-clients';
import { authWSClient } from 'WSClient';
import CONFIG from 'Config';
import { MarketOfferClass, MarketOfferBidClass } from 'Classes';
import { getItemFromStoreAsBoolean } from 'Utils/storage';
import {
  SET_ALL,
  UPDATE_OFFER_DATA_BY_ID,
  UPDATE_BID_DATA_BY_ID,
  ADD_OFFER_TO_LIST,
  ADD_MESSAGE,
} from './mutation-types';

export default {
  resetMarket() {
    authWSClient.unsubscribe('market');
  },
  setupNotification({ dispatch }) {
    authWSClient.subscribe(
      'market',
      null,
      message => dispatch('handleNotification', message),
    );
  },
  handleNotification({ dispatch, commit }, message) {
    const { message: messageBody } = message;
    switch (message.event) {
      case 'updateOfferList': {
        dispatch('getMarketOfferList');
        break;
      }
      case 'addOffer': {
        dispatch('addMarketOfferToList', messageBody);
        break;
      }
      case 'updateOffer': {
        const { id, ...data } = messageBody;
        commit(UPDATE_OFFER_DATA_BY_ID, { id, data });
        break;
      }
      case 'updateBid': {
        const { id, ...data } = messageBody;
        commit(UPDATE_BID_DATA_BY_ID, { id, data });
        break;
      }
      case 'marketStatus': {
        dispatch('setMarketStatus', messageBody.open);
        break;
      }
      case 'message': {
        commit(ADD_MESSAGE, messageBody);
        break;
      }
    }
  },
  async getMarketOfferList({ commit }) {
    commit(SET_ALL, { marketOfferListLoading: true });
    try {
      const { data } = await httpClientMarket.get('/offers');
      const marketOfferList = (data.data || []).map(item => new MarketOfferClass(item));
      commit(SET_ALL, {
        marketOfferList,
        marketOfferListLoaded: true,
        marketOfferListLoading: false,
      });
      return marketOfferList;
    } finally {
      commit(SET_ALL, { marketOfferListLoading: false });
    }
  },
  async getMarketUserBidList({ commit }, { search } = {}) {
    const searchValue = encodeURIComponent(search || '');
    const { data } = await httpClientMarket.get(`/bid?search=${searchValue}`);
    const marketUserBidList = (data.data || []).map(bid => new MarketOfferBidClass(bid));
    commit(SET_ALL, {
      marketUserBidList,
      marketUserBidListLoaded: true,
    });
    return marketUserBidList;
  },
  addMarketOfferToList({ commit }, offerData) {
    commit(ADD_OFFER_TO_LIST, new MarketOfferClass(offerData));
  },
  async cancelMarketUserBid({ dispatch }, bidId) {
    await httpClientMarket.delete(`/bid/${bidId}`);
    await dispatch('getMarketUserBidList');
  },
  async cancelMarketOffer({ dispatch }, orderId) {
    await httpClientMarket.delete(`/offer/${orderId}`);
    const promises = [];
    promises.push(dispatch('investment/refreshInvestmentsData', '', { root: true }));
    await Promise.all(promises);
  },
  async setMarketStatus({ commit }, isMarketOpen) {
    let isMarketOpenValue = isMarketOpen;
    // To manual set is market open for test purpose set localStorage item with name is-market-open to true or false
    // Only for Dev or Stage environment
    if ((CONFIG.isEnvStag || CONFIG.isEnvDev) && localStorage.getItem('is-market-open')) {
      const isMarketOpenValueStorage = getItemFromStoreAsBoolean('is-market-open');
      if (typeof isMarketOpenValueStorage === 'boolean') isMarketOpenValue = isMarketOpenValueStorage;
    }
    commit(SET_ALL, { isMarketOpen: isMarketOpenValue });
  },
};
